<template>
  <div :class="[isShow == true?'headSide_metail h27 ':'headSide_metail']">
    <div class="brief">
        <div class="portrait">
            <div class="portrait_box">
              <img class="portrait_img" :src="data.headUrl">
            </div>

            <!--图标-->
            <div v-if="status !=-1" class="exper_icon">
               <img v-if="isImg == true" src="@/assets/images/mer_vip.png" alt="">
               <img v-if="isExpert == true" src="@/assets/images/expert_vip.png" alt="">
               <span :class="[portText =='个人'?'color_1':'color_2']">{{portText}}</span>
            </div>
        </div>
        <div style="flex:1;margin-left:47px;margin-top:42px;" >
            <div class="wer">
            <span class="user_name">{{data.name}}</span>
            <span class="user_text" @click="onGrde()">{{personStatus(data.status)}}</span>
            <!-- <button class="release" @click.prevent="release()">我要发布</button> -->
            </div>
            <div class="synopsis">
            <p class="mt-12">
                <span>联系电话:</span>
                <span style="margin-left:5px;">{{data.mobile}}</span>
            </p>
                <p class="mt-12">
                <span>电子邮箱:</span>
                <span style="margin-left:5px;">{{data.email}}</span>
            </p>
            </div>
        </div>
    </div>
    <div  class="head_top">
        <div :class="[isShow?'head_patr ml-45':'head_patr m-l-8']">
          <span class="head_font">总收入 :</span>
          <span style="color:#FF7402;">￥</span>
          <span class="maery_font">{{tranNumber(balaInfo.total_income)}}</span>
        </div>
        <div :class="[isShow?'head_patr ml-33':'head_patr m-l-11']">
          <span class="head_font">余额 :</span>
          <span class="head_fonts">￥{{tranNumber(balaInfo.balance)}}</span>
        </div>
        <div :class="[isShow?'head_patr ml-33':'head_patr m-l-11']">
          <span class="head_font">已提现 :</span>
          <span class="head_fonts">￥{{tranNumber(balaInfo.withdraw)}}</span>
        </div>
        <div v-if="isShow == true" class="head_comment">
           <!--新增充值接口，2021年12月14日10:33:38-->
           <button @click="dialogFormVisible = true" >充值</button>
           <button @click.prevent="chshout()">提现</button>
            <span v-if="cashoutper>0" :title="'满'+cashoutpoint+'元可提现,单次可申请提现'+cashoutper+'元'">满{{cashoutpoint}}元可提现</span>
            <span v-else>满{{cashoutpoint}}元可提现</span>
        </div>
    </div>

    <!--充值弹框，2021年12月14日10:45:54-->
    <el-dialog title="充值金额" :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="info">
        <el-form-item label="充值金额" :label-width="formLabelWidth">
          <el-input v-model="info.amount" placeholder="自定义金额" autocomplete="off" style="position:relative;width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="快速充值" :label-width="formLabelWidth">
          <el-radio class="recharge" v-model="info.amount" label="10" border>10元</el-radio>
          <el-radio class="recharge" v-model="info.amount" label="20" border>20元</el-radio>
          <el-radio class="recharge" v-model="info.amount" label="50" border>50元</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="toRecharge">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {myfunds,getcashoutinfo,recharge} from '@/api/coment'
import {getSelfUserinfo} from '@/api/user'
export default {
  props:["isShow"],
  data(){
    return{
      info:{
        amount: ""    //充值金额
      },
      dialogFormVisible:false,    //金额选择弹框
      formLabelWidth:'120px',  //输入框大小
      cashoutpoint:0,
      cashoutper:0,
      data:{},
      status:'',
      balaInfo:{},
      portText:'',
      statusList: ["待认证", "认证通过", "认证拒绝"],
      isImg:false,
      isExpert:false
    }
  },
  created(){
   this.getcashoutctl();
   this.data = this.$store.state.user.userInfo.data;
   this.status = this.$store.state.user.userInfo.data.status;
   let obj = this.$store.state.user.userInfo.data2;
   this.getMyfunds();
   switch(obj.id){
     case 1:
      this.isImg = false;
      break;
     case 2:
      this.portText ='个人'
      this.isImg = true;
	    break;
    case 3:
      this.portText ='专家'
      this.isExpert = true;
      break;
   }
  },
  methods:{
  //获取提现参数
    getcashoutctl(){
        getcashoutinfo().then((res)=>{
          if(0==res.code){
             for (let index = 0; index < res.page.length; index++) {
               let element = res.page[index];
               if("cashoutA1"==element.name){
                  this.cashoutper=element.cvalue
               }else if("cashoutPoint"==element.name){
                  this.cashoutpoint=element.cvalue;
               }
             }

          }
        })
    },
    //提现
    chshout(){
      getSelfUserinfo().then((res)=>{
        if(res.code == 0){
            if(res.data.status == 0){
              this.$alert('身份信息审核中，请稍后..','信息提示',{
                confirmButtonText: '确定',
                callback: action => {}
              })
            }else{
              if (res.data.idFront == "" || res.data.idBack == ""){
                this.$alert('请先完善身份信息','信息提示',{
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$router.push({path:'/corporate_card'})
                  }
                })
              }else{
                if(this.balaInfo.balance >=this.cashoutpoint){
                  this.$emit('onWithdrawal')
                }else{
                  this.$message({
                  message:'满'+this.cashoutpoint+'元才可提现',
                  type:'warning',
                  duration:1000
                  })
                return false;
              }
              }
            }
        }
      })
    },

    //充值 2021年12月14日10:48:57
    toRecharge(){
      let params = {
        amount:this.info.amount
      }
      recharge(params)
        .then((res) => {
          this.orderNo = res.data.orderNo;
          if (res.code === 0) {
            // console.log("充值订单信息")
            // console.log(res)
            localStorage.setItem("list", JSON.stringify(res.data));
            localStorage.setItem("title", "智污邦环保服务平台账户余额充值");
            let url = window.location.href.split("//")[1];
            let host = window.location.host;
            let str = url.replace(host,"");
            str = str.substring(1);
            sessionStorage.setItem('url',str);
            this.$router.push({
              name: "payment"
            });
          }
        })
    },

    //发布需求
    release(){
      this.$emit('release')
    },
    //获取用户余额
    getMyfunds(){
      myfunds().then((res)=>{
        if(res.code ==0){
          this.balaInfo = res.data;
        }
      }).catch((err)=>{});
    },
    personStatus(status){
      if(status == -1){
        status = 0
      }
      return this.statusList[status];
    },
    tranNumber(num){
      num = Number(num);
      if (num == 0) {
        return num + '';
      } else
      if (num > 0 && num < 10000) {
        return num + '';
      } else {
        return (num / 10000).toFixed(2) + '万';
      }
    },
    onGrde(){
     if(this.status == -1 || this.status == 0){
        this.$router.push({
		    path:'/membership',
		    query:{type:1}
		    })
      }
    }
  }
}
</script>

<style scoped="scoped">
.h27{
  height: 270px;
}
.headSide_metail{
  width: 100%;
  border-left: 1px solid #EEEEEE;
  border-bottom: 1px solid #EEEEEE;
  border-right: 1px solid #EEEEEE;
  border-top: 2px solid #99CF2A;
  display:flex;
  flex-direction: column;
}
.brief{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.portrait{
    width: 150px;
    height: 150px;
    margin-left: 38px;
    margin-top: 30px;
    position: relative;
}
.portrait_box{
    width: 149px;
    height: 147px;
    border-radius: 50%;
    overflow: hidden;
}
.portrait_img{
   width: 149px;
   height: 147px;
}
.mer{
   position: absolute;
   top: 134px;
   left: 153px;
   z-index: 100 !important;
}
.wer{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 15px;
  margin-right: 30px;
}
.user_name{
  width:16%;
  height: 33px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 38px;
  padding-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  margin-right: 15px;
}
.user_text{
  width: 61px;
  height:27px;
  line-height: 27px;
  border-radius:3px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  display: inline-block;
  margin-top: 5px;
  border: 1px solid #eeeeee;
}
.user_text:hover{
 cursor: pointer;
}
.release{
  width: 114px;
  height: 35px;
  background: #68BE32;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
.synopsis{
  display: flex;
  flex-direction: column;
  text-align: left;
}

.mt-12{
  margin-top: 12px;
}
.head_top{
  display: flex;
  justify-content:flex-start;
  align-items: center;
  margin: 25px 0px;
  position: relative;
}
.head_patr{
  text-align: left;
}

.ml-45{
  margin-left: 45px;
}
.ml-33{
  margin-left: 33px;
}
.m-l-8{
  margin-left:8%;
}
.m-l-11{
 margin-left: 11%;
}
.m-l-9{
   margin-left: 9%;
}
.m-l-5{
   margin-left: 5%;
}

.head_font{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.head_fonts{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.maery_font{
  font-size: 24px;
  font-family: Arial;
  font-weight: 400;
  color: #FF7402;
}
.head_comment{
  width: 200px;
  position: absolute;
  /*display: flex;*/
  display: inline;
  flex-direction: column;
  top:-10px !important;
  right: 33px !important;
}
.head_comment button{
  /*width: 114px !important;*/
  width: 90px !important;
  height: 35px !important;
  border-radius: 3px !important;
  color: #333333;
  background: #ffffff;
  border: 1px solid #333333;
}
.head_comment span{
  margin-top: 8px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
  float: right;
  margin-right: 13px;
}


.exper_icon{
  position: absolute;
  top: 97px;
  right: -9px;
  width: 60px;
}
.exper_icon img{
  width: 32px;
  margin-right: 2px;
  margin-top: 10px;
}
.exper_icon span{
  font-size: 12px;
  color: #75B215;
  position: absolute;
  margin-left: -14px;
  margin-top: 26px;
  position: absolute;
}

.color_1{
  color: #75B215 !important;
}
.color_2{
  color: #1296db !important;
}

/*充值金额按钮*/
.el-radio {
  color: #606266;
  cursor: pointer;
  margin-right: 16px;
  margin-left: 17px;
}
</style>



// WEBPACK FOOTER //
// src/common/headSide.vue